"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _constants = require("../constants");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function getModalWidth(_ref) {
  var width = _ref.width,
    size = _ref.size,
    theme = _ref.theme;
  if (width) {
    return width;
  }
  if (size === _constants.MODAL_SIZE.BIG) {
    return theme.widthLarge;
  }
  if (size === _constants.MODAL_SIZE.SMALL) {
    return theme.widthSmall;
  }

  // MODAL_SIZE.SMALL & Default
  return theme.width;
}
function getModalHeight(_ref2) {
  var height = _ref2.height,
    theme = _ref2.theme;
  if (height) {
    return "height: ".concat(height, ";");
  }
  return "\n    min-height: ".concat(theme.minHeight, ";\n    max-height: calc(100% - ").concat(theme.modalOffsetMinimal, ");\n  ");
}

/**
 * Return the button shadow based on props
 * @param {Object} props
 * @return {String}
 */
function getModalBoxShadow(_ref3) {
  var hasShadow = _ref3.hasShadow,
    theme = _ref3.theme;
  return "box-shadow: ".concat(hasShadow ? "".concat(theme.shadowSize, " ").concat(theme.shadowColor) : 'none');
}
var Content = _styledComponents["default"].div.attrs(function (_ref4) {
  var testId = _ref4.testId;
  return _objectSpread({}, (0, _oxygenConfig.getTestAttributes)(testId));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  width: ", ";\n  max-width: calc(100% - ", ");\n  background: ", ";\n  ", ";\n  border-radius: ", ";\n  position: relative;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  ", ";\n  z-index: ", ";\n  overflow: auto;\n"])), getModalHeight, getModalWidth, function (_ref5) {
  var theme = _ref5.theme;
  return theme.modalOffsetMinimal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.backgroundColor;
}, function (props) {
  return getModalBoxShadow(props);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.animation;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.zIndex;
});
var _default = Content;
exports["default"] = _default;